/* tslint:disable */
/* eslint-disable */
/**
 * Vocabulary Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface VocabularyAsSet
 */
export interface VocabularyAsSet  {
    /**
     * 
     * @type {string}
     * @memberof VocabularyAsSet
     */
    vocabulary?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof VocabularyAsSet
     */
    notations?: { [key: string]: string; };
}

/**
 * Check if a given object implements the VocabularyAsSet interface.
 */
export function instanceOfVocabularyAsSet(value: object): value is VocabularyAsSet {
    return true;
}

export function VocabularyAsSetFromJSON(json: any): VocabularyAsSet {
    return VocabularyAsSetFromJSONTyped(json, false);
}

export function VocabularyAsSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): VocabularyAsSet {
    if (json == null) {
        return json;
    }
    return {
        
                  'vocabulary': json['vocabulary'] == null ? undefined : json['vocabulary'],
                  'notations': json['notations'] == null ? undefined : json['notations'],
    };
}

export function VocabularyAsSetToJSON(json: any): VocabularyAsSet {
    return VocabularyAsSetToJSONTyped(json, false);
}

export function VocabularyAsSetToJSONTyped(value?: VocabularyAsSet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'vocabulary': value['vocabulary'],
        'notations': value['notations'],
    };
}


